import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleCopy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeopleCopy"><Path fillRule="evenodd" clipRule="evenodd" d="M18 2H2V18H6V22H22V6H18V2ZM16 6V4H4V16H6V6H16ZM14 14.5C15.3807 14.5 16.5 13.3807 16.5 12C16.5 10.6193 15.3807 9.5 14 9.5C12.6193 9.5 11.5 10.6193 11.5 12C11.5 13.3807 12.6193 14.5 14 14.5ZM19 20C16.7652 14.6667 11.2348 14.6667 9 20H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleCopy;
